import { useDispatch, useSelector } from "react-redux";
import { Col, Row } from "reactstrap";
import { images } from "../../assets";
import { fileUrl } from "../../redux/base/url";
import garageCart from "../../redux/garageCart";
import { GarageCartItem } from "../../redux/garageCart/type";
import { getLocalized } from "../../redux/localization";
import "./style.scss";

const GarageCard = ({ data }: { data?: GarageCartItem }) => {
  const dispatch = useDispatch();
  const localize = useSelector(getLocalized);
  return (
    <div className="divider-div garage-card">
      <Row>
        <Col md={6}>
          <div className="boldText">
            {data?.Car?.CarBrand} {data?.Car?.CarModel}
          </div>
          <span className="subText">
            {data?.Car?.CarVersion} {data?.Car?.CarPack}
          </span>
          <div className="subText">
            <div>{localize.getString("monthlyprice")}</div>
            <span className="boldText">
              {" "}
              {new Intl.NumberFormat("tr-TR", {
                maximumSignificantDigits: 20,
              }).format(
                data?.Price?.PricePerMonth ? data?.Price.PricePerMonth : 0
              )}{" "}
              TL KDV
            </span>
          </div>
        </Col>
        <Col md={6}>
          {data?.Car?.CarImages && (
            <>
              {" "}
              <img
                alt=""
                className="gdc-trash"
                src={images.trash}
                width={15}
                style={{
                  cursor: "pointer",
                  position: "absolute",
                  zIndex: 1035,
                  right: 10,
                }}
                onClick={() => {
                  dispatch(garageCart.actions.removeToGarage(data));
                }}
              />
              <img
                src={fileUrl(data?.Car?.CarImages.FrontRightImage)}
                alt=""
                style={{ cursor: "pointer", position: "relative" }}
                width="100%"
              />
            </>
          )}
        </Col>
      </Row>
    </div>
  );
};
export default GarageCard;
